import $ from "jquery";
import VideoModal from "modals/VideoModal";
import PageAnimations from "webPage/PageAnimations";
import Page from "webPage/Page";

Page.register('/break-management-software', function () {
    PageAnimations.start();

    $('body').on('click', '.js-play-video', function(){
        let id = $(this).attr('data-video-id');
        let modal = new VideoModal(id);
        modal.show();

        return false;
    });
});
